/* eslint-disable max-len */
import { ICONS_ID } from '@bitComponents/unifiedIcons/SvgIconLoader';
import { CQ_ACTION_CODES, CQ_POTS } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.se.risk.subject]: 'TELCOBI eSim Riesgo Error 800',
      [STRING_KEYS.se.order.subject]: 'TELCOBI eSim Error TELCO',
      [STRING_KEYS.process.title]: 'Quiero activar eSIM',
      [STRING_KEYS.stepTitles.afterSaleParentProductSelector]: 'Línea móvil donde quieres activar eSIM',
      [STRING_KEYS.afterSaleParentProductInfoBar.icon]: ICONS_ID.Movil,
      [STRING_KEYS.summary.staticDirectDebit]: '',
      [STRING_KEYS.summary.cart.oneTimeChargesTitle[CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]]: '',
      [STRING_KEYS.summary.afterSaleParentProductSelected.title]: 'Solicitud tarjeta eSIM',
      [STRING_KEYS.summary.afterSaleParentProductSelected.phoneNumberLabel]: 'Línea asociada a la eSIM',
      [STRING_KEYS.summary.afterSaleParentProductSelected.adviceIcon]: ICONS_ID.Informacion,
      [STRING_KEYS.summary.afterSaleParentProductSelected.advice]: 'Es necesario que conectes tu línea {phoneNumber} a una red WiFi antes de confirmar el pedido.',
      [STRING_KEYS.confirmation.title]: 'Pedido realizado con éxito',
      [STRING_KEYS.confirmation.subtitle]: 'En unos minutos tendrás disponible la descarga de la eSIM en tu área privada.',
      [STRING_KEYS.confirmation.subtitle2]: '',
      [STRING_KEYS.confirmation.thankYouMsg]: 'Muchas gracias por confiar en Movistar.',
      [STRING_KEYS.confirmation.primaryButtonLabel]: 'Instalar mi eSIM',
      [STRING_KEYS.confirmation.primaryButtonLink]: 'https://www.movistar.es/area-cliente/gestiones/linea-movil/e-sim/?esim=true&status=en-curso&productId={productId}',
      [STRING_KEYS.confirmation.secondaryButtonLabel]: '',
      [STRING_KEYS.confirmation.secondaryButtonLink]: '',
      [STRING_KEYS.confirmation.adviceIcon]: ICONS_ID.Informacion,
      [STRING_KEYS.confirmation.advice]: 'Recuerda que necesitas estar conectado a una red WiFi para instalar la eSIM.',
      [STRING_KEYS.campaignCode]: 'eSim_activacion_pendiente',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  selfEmployed: {
    everyMainSelection: {
      [STRING_KEYS.se.risk.subject]: 'TELCOBI eSim Riesgo Error 800 AU',
      [STRING_KEYS.se.order.subject]: 'TELCOBI eSim Error TELCO AU',
    },
  },
};
